<template>
    <div class = "dispatch-button">
        <a @click.stop="onPlus" v-if="plusActive">
            <v-icon
                :color = "user && hasEntriesWithoutUser ? 'success' : 'secondary'"
                class  = "toolbar-button"
                size   = "20"
            >
                mdi-account-plus
            </v-icon>
        </a>

        <a @click.stop="onMinus" v-if="minusActive" >
            <v-icon
                :color = "hasEntriesWithUser ? 'red' : 'secondary'"
                class  = "toolbar-button"
                size   = "20"
            >
                mdi-account-minus
            </v-icon>
        </a>
    </div>
</template>

<script>
export default {
    name: "PDispatchButtons",

    props: {
        /**
         * True if the + button should be displayed
         */
        plusActive: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        /**
         * True if the - button should be displayed
         */
        minusActive: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        /**
         * The units of a location if the buttons belong to al location. Null, if the buttons belong to a single unit
         */
        units: {
            required: false,
            default : function () {
                return null;
            }
        },

        /**
         * The currently selected user
         */
        user: {
            required: false,
            default : function () {
                return null;
            }
        }
    },

    computed: {
        hasEntriesWithUser () {
            if (!this.units) {
                return true;
            }

            return this.units.find (unit => unit.order && unit.order.id && unit.technicianId);
        },

        hasEntriesWithoutUser () {
            if (!this.units) {
                return true;
            }

            return this.units.find (unit => unit.order && unit.order.id && !unit.technicianId);
        }
    },

    methods: {
        onPlus () {
            if (!this.user || !this.hasEntriesWithoutUser) {
                return;
            }

            this.$emit ("plus");
        },

        onMinus () {
            if (!this.hasEntriesWithUser) {
                return;
            }

            this.$emit ("minus");
        },
    }
}
</script>

<style scoped>

.dispatch-button {
    display: flex;
    min-width: 30px
}

</style>